import React from "react";
import "../user-management-list-filter-options/filter-options-usermgmt.scss";
import { TextInputComponent } from "../../../../../common/components";

interface TextFilterProps {
  value: string;
  error?: string;
  onChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  isFirstNameEnabled: boolean;
}

const FirstNameFilter: React.FC<TextFilterProps> = ({
  value,
  error,
  onChange,
  isFirstNameEnabled,
}) => {
  if (!isFirstNameEnabled) return null;

  return (
    <div className="tenant-filter-options-text-wrapper">
      <div className="filter-options-tenant-filters">
        <TextInputComponent
          type="text"
          fieldName="firstName"
          placeholder="Enter First Name"
          optional={false}
          disabled={!isFirstNameEnabled}
          value={value}
          onChange={onChange}
        />
      </div>
    </div>
  );
};

export default FirstNameFilter;